import { Injectable } from "@angular/core";
import { RestService } from "../../../services/rest.service";


@Injectable({
  providedIn: 'root'
})
export class ApiCreditService {

  public static ApiEndpoint = 'api-credit';

  constructor(private restService: RestService) {
  }


  fetchBalance() {
    return this.restService.send<{ balance: number }>({
      url: `${ApiCreditService.ApiEndpoint}/balance`,
      method: 'GET',
    })
  }
}
